import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { BUSINESS, waLink } from "../lib/zoco";
import { LogoMark } from "./Logo";

const NAV = [
  { id: "inicio", label: "Inicio" },
  { id: "productos", label: "Productos" },
  { id: "sobre-nosotros", label: "Nosotros" },
  { id: "contacto", label: "Contacto" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#F7F1E3]/90 border-b border-[#D9CFB6]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <a
          href="#inicio"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
          onClick={close}
        >
          <LogoMark size={42} />
          <div className="flex flex-col leading-none">
            <span className="font-display text-2xl md:text-3xl tracking-tight text-[#034638]">
              Zoco <span className="italic">Fruits</span>
            </span>
            <span className="hidden md:inline-flex font-sans-z text-[8px] tracking-[0.3em] uppercase text-[#5C6E6A] mt-1.5">
              Fruits &amp; Vegetables
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={`nav-link-${n.id}`}
              className="font-sans-z text-[11px] tracking-[0.22em] uppercase font-medium text-[#1A2823] hover:text-[#034638] transition-colors duration-300"
            >
              {n.label}
            </a>
          ))}
          <a
            href={waLink(`Hola ${BUSINESS.name}, quería preguntar por un pedido.`)}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-cta"
            className="inline-flex items-center gap-2 font-sans-z text-[11px] tracking-[0.22em] uppercase font-semibold px-5 py-3 bg-[#034638] text-white hover:bg-[#0B5A4A] transition-colors duration-300"
          >
            <MessageCircle size={14} strokeWidth={2} />
            Pedir
          </a>
        </nav>

        <button
          className="md:hidden p-2 text-[#034638]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menú"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} strokeWidth={1.8} /> : <Menu size={24} strokeWidth={1.8} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-[#D9CFB6] bg-[#F7F1E3]/98 backdrop-blur-xl"
          data-testid="mobile-menu"
        >
          <nav className="flex flex-col px-6 py-7 gap-5">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={close}
                data-testid={`mobile-nav-link-${n.id}`}
              className="font-display text-3xl md:text-4xl tracking-tight text-[#034638]"
              >
                {n.label}
              </a>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              onClick={close}
              data-testid="mobile-whatsapp-cta"
              className="mt-3 inline-flex items-center justify-center gap-2 font-sans-z text-[11px] tracking-[0.22em] uppercase font-semibold px-5 py-4 bg-[#034638] text-white"
            >
              <MessageCircle size={14} strokeWidth={2} />
              Pedir por WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
